
import { DefectModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { defectsStore } from '@/libs/defects/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({})
export default class DefectSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: false }) truncateSelection!: boolean;
    @Prop({ default: false }) chips!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): DefectModel[] {
        const items = [...(defectsStore.useGetter(CrudGetter.Data) as DefectModel[])];
        return items.sort((a: DefectModel, b: DefectModel) => {
            return (a.code || '').localeCompare(b.code || '');
        });
    }

    mounted() {
        defectsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
    }

    getDisplay(e: DefectModel) {
        return `${e.code} - ${e.name}`;
    }
}
